/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_IcoInputs */

const cs_property_registry_ico = /** @type {(inputs: Property_Registry_IcoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČO`)
};

const en_property_registry_ico = /** @type {(inputs: Property_Registry_IcoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČO`)
};

/**
* | output |
* | --- |
* | "IČO" |
*
* @param {Property_Registry_IcoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_ico = /** @type {((inputs?: Property_Registry_IcoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_IcoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_ico(inputs)
	return cs_property_registry_ico(inputs)
});